/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Meta_Shown_Events_PartialInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{shownFormatted} of {totalFormatted} archived event" |
* | * | "{shownFormatted} of {totalFormatted} archived events" |
*
* @param {Meta_Shown_Events_PartialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_events_partial = /** @type {((inputs: Meta_Shown_Events_PartialInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Events_PartialInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const shownFormatted = registry.number("de", i?.shown, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Event im Archiv`);
		return /** @type {LocalizedString} */ (`${shownFormatted} von ${totalFormatted} Events im Archiv`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const shownFormatted = registry.number("fr", i?.shown, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} événement archivé`);
		return /** @type {LocalizedString} */ (`${shownFormatted} sur ${totalFormatted} événements archivés`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hans", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted}场已归档赛事中的${shownFormatted}场`);
		return /** @type {LocalizedString} */ (`${totalFormatted}场已归档赛事中的${shownFormatted}场`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const shownFormatted = registry.number("zh-Hant", i?.shown, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 場已歸檔賽事中的 ${shownFormatted} 場`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 場已歸檔賽事中的 ${shownFormatted} 場`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const shownFormatted = registry.number("ko", i?.shown, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`아카이브된 이벤트 ${totalFormatted}개 중 ${shownFormatted}개`);
		return /** @type {LocalizedString} */ (`아카이브된 이벤트 ${totalFormatted}개 중 ${shownFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const shownFormatted = registry.number("en", i?.shown, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} archived event`);
		return /** @type {LocalizedString} */ (`${shownFormatted} of ${totalFormatted} archived events`)
	}
});